import { type CSSProperties, type PropsWithChildren, PureComponent } from "react";
import Joyride, { type CallBackProps } from "react-joyride";
import { connect } from "react-redux";

import { type ITip } from "../../app-utils/help.js";
import { hideTipsAreOff } from "../../redux/modules/auth.js";
import { type IAppState } from "../../redux/reducer.js";
import { joyRideFloaterStyles, joyRideStyles } from "./TipTour.js";

interface ITipAreOffOwnProps {
  tip: ITip;
}

interface ITipAreOffAppStateProps {
  showTip: boolean;
}

interface ITipAreOffDispatchProps {
  // methods used in mapDispatchToProps
  hideTipsAreOff: () => void;
}

// combined props
export interface ITipAreOffProps extends ITipAreOffOwnProps, ITipAreOffAppStateProps, ITipAreOffDispatchProps {
  children: any;
  style?: CSSProperties;
}

function mapStateToProps(state: IAppState, _ownProps: ITipAreOffOwnProps): ITipAreOffAppStateProps {
  return {
    showTip: state.auth.showTipsAreOff,
  };
}

function mapDispatchToProps(dispatch): ITipAreOffDispatchProps {
  return {
    hideTipsAreOff: () => dispatch(hideTipsAreOff()),
  };
}

interface ITipAreOffState {
  run?: boolean;
}

/**
 * Wrapper component around a page that shows some tips with highlighted beacons.
 *
 * created on 10/11/2017
 */
class TipAreOff extends PureComponent<ITipAreOffProps, ITipAreOffState> {
  state = {
    run: false,
  };

  componentDidUpdate(prevProps: Readonly<ITipAreOffProps>) {
    if (this.props.showTip !== prevProps.showTip) {
      setTimeout(() => this.setState({ run: this.props.showTip }), 200);
    }
  }

  tourCallback = (data: CallBackProps) => {
    if (data.action === "close" || data.action === "esc" || data.type === "finished" || data.action === "reset") {
      this.props.hideTipsAreOff();
    }
  };

  render() {
    const tipsAreOffTip: ITip = { ...this.props.tip, isFixed: true, disableBeacon: true };
    return (
      <span style={this.props.style}>
        {this.state.run === true && (
          <Joyride
            steps={[tipsAreOffTip]}
            run={true}
            debug={false}
            disableOverlay={true}
            showSkipButton={false}
            continuous={true}
            locale={{ back: "Back", close: "Close", last: "OK" }}
            callback={this.tourCallback}
            styles={joyRideStyles as any}
            floaterProps={joyRideFloaterStyles}
          />
        )}

        {this.props.children}
      </span>
    );
  }
}

export default connect<ITipAreOffAppStateProps, ITipAreOffDispatchProps, PropsWithChildren<ITipAreOffOwnProps>>(
  mapStateToProps,
  mapDispatchToProps,
)(TipAreOff);
